module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_0.7d02f809.png";